module.exports = __webpack_public_path__ + "static/media/recovery-logoideation.f4a09697.png";